
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SubscriptionProvider, useSubscription } from "@/contexts/SubscriptionContext";
import { UsageStats } from "@/components/subscription/UsageStats";
import { Badge } from "@/components/ui/badge";
import { ChartPie } from "lucide-react";
import { BillingPricingCard } from "@/components/pricing/BillingPricingCard";

const CurrentTierDisplay = () => {
  const { subscription } = useSubscription();
  
  if (!subscription) return null;
  
  return (
    <Card className="bg-card border-border rounded-sm">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-foreground flex items-center gap-2">
          <ChartPie className="h-4 w-4" />
          Evaluation Credits Available
        </CardTitle>
      </CardHeader>
      <CardContent>
        <h3 className="text-2xl font-semibold text-foreground">
          {subscription.tier_name}
        </h3>
      </CardContent>
    </Card>
  );
};

const Billing = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-8">
        <div className="space-y-8">
          <h1 className="text-2xl font-semibold text-foreground">
            Evaluation Credits & Usage
          </h1>

          <SubscriptionProvider>
            <CurrentTierDisplay />
            
            <Card className="bg-card border-border rounded-sm">
              <CardHeader>
                <CardTitle className="text-foreground">Current Usage</CardTitle>
              </CardHeader>
              <CardContent>
                <UsageStats />
              </CardContent>
            </Card>

            <Card className="bg-card border-border rounded-sm">
              <CardHeader>
                <CardTitle className="text-foreground">Evaluation Purchase Options</CardTitle>
              </CardHeader>
              <CardContent>
                <BillingPricingCard />
              </CardContent>
            </Card>
          </SubscriptionProvider>
        </div>
      </div>
    </div>
  );
};

export default Billing;
